import * as React from 'react';

const MenuIcon = () => (
  <svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="25" height="3" rx="1.5" fill="black"/>
    <rect y="7" width="17" height="3" rx="1.5" fill="black"/>
    <rect y="14" width="25" height="3" rx="1.5" fill="black"/>
  </svg>
);

export default MenuIcon;
